import { render, staticRenderFns } from "./HubblePlotYAxisScaleControl.vue?vue&type=template&id=4299ea42&scoped=true"
import script from "./HubblePlotYAxisScaleControl.vue?vue&type=script&lang=ts"
export * from "./HubblePlotYAxisScaleControl.vue?vue&type=script&lang=ts"
import style0 from "./HubblePlotYAxisScaleControl.vue?vue&type=style&index=0&id=4299ea42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4299ea42",
  null
  
)

export default component.exports